import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker   } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import camera from '../../assets/images/icon/camera.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}




const storedFiles=[];

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			children_id: 1,
			details: '',
			image: '',
			video: '',
			file: '',
			loading: false,
  		    iconLoading: false,
  		    all_day: 0,
  		    notify: 0,
  		    permision: '',
  		    onChangejoining: '',
  		    first_name: '',
  		    last_name: '',
  		    mobile: '',
  		    email: '',
  		    gender: '',
  		    address: '',
  		    birthday: '',
  		    blood_group: '',
  		    joining_date: '',
  		    permision: '',
  		    program_id: '',
  		    program: [],
  		    program_list: [],
			previewImage: '',
			previewTitle: '',
			previewVisible: false,
			file_list: [],
			file_list_pdf: [],
			file_list_audio: [],
		}
		
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onChangechecked = this.onChangechecked.bind(this);
		this.onChangebirthday = this.onChangebirthday.bind(this);
		this.onChangejoining = this.onChangejoining.bind(this);
		this.change_gender = this.change_gender.bind(this);
		this.change_blood_group = this.change_blood_group.bind(this);
		this.goBack = this.goBack.bind(this);
		this.onChangecheckedprog = this.onChangecheckedprog.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 staff_id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
							program_id: result['data'][0]['id'],
						});
					}else{
						this.setState({
							program_list: [],
						});
					}
				}
			});		
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
	if(e.target.name){
		document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
	}
	if(e.target.name == 'email'){
		 var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		 if (pattern.test(e.target.value)) {
			document.getElementById("email_error").innerHTML = "";
			document.getElementById("submit_btn").disabled = false;
		  }else{
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById("email_error").innerHTML = "Please Enter Valid Email !!!";
			document.getElementById("submit_btn").disabled = true;
		  }
	}
	if(e.target.name == 'mobile'){
		 var pattern = new RegExp(/^[0-9\b]+$/);
		 if (!pattern.test(e.target.value)) {
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById("mob_error").innerHTML = "Please Enter Only Number !!!";
			document.getElementById("submit_btn").disabled = true;
		  }else if(e.target.value.length != 10){
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById("mob_error").innerHTML = "Please Enter Valid Phone Number. !!!";
			document.getElementById("submit_btn").disabled = true;
		  }else{
			document.getElementById("mob_error").innerHTML = "";
			document.getElementById("submit_btn").disabled = false;
		  }
	}
  };
  
  openQuantity(e){
		this.setState({ program_id: e });
	}  
	
	onChangechecked(checkedValues) {
	 this.setState({ permision: checkedValues });
	}
	
	onChangecheckedprog(checkedValues) {
	 this.setState({ program: checkedValues });
	}

	onChangebirthday(date, dateString) {
	  this.setState({ birthday: dateString });
	}
	
	onChangejoining(date, dateString) {
	  this.setState({ joining_date: dateString });
	}
	
	change_gender(event){
         this.setState({gender: event});
     }
	 
	change_blood_group(event){
         this.setState({blood_group: event});
     }
	 
	 handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
    
      getData('erp/add_staff',this.state).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error(result.message,2);
			this.setState({ loading: false });
          }
		  if(result.status==200){
			message.config({ top: 150});
			const selectedFiles = this.state.file_list;
			
			const data = new FormData() ;
			
			const image = [] ;
			
			if(selectedFiles.length == 0){
				data.append(`image[0]`, '[]')
			}
			
			
			for (let i = 0; i < selectedFiles.length; i++) {
				data.append(`image[${i}]`, selectedFiles[i].selectedFiles)
			}
			
			
			
			data.append('id', result.id);	     
			data.append('type', 'staff');	     
								data.append('user_id', this.state.user_id)
								let url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_student_pic";
								axios.post(url, data, {
								})
								.then(res => {
										message.config({ top: 150});
										message.success('Staff added',2);
										this.setState({ loading: false });
										this.setState({comment_text:''});
										window.location.href = '/staff-profiles/index';
			})

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }	
  
  handleFileSelect = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFiles.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'image',
							selectedFiles: f
						}
						storedFiles.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list:storedFiles});
		}, 500);
	} 

	removeFile= (file,e) =>{
		for (var i = 0; i < storedFiles.length; i++) {
			if (storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFiles.length=='0') {
				const file = document.querySelector('.file');
				//file.value = '';
			}			
			this.setState({file_list:storedFiles});
			//console.log(storedFiles);
		}, 500);
	}
	
  goBack(){
		window.location.href = '/staff-profiles/index';
	}
	 
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Add Staff Profile</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/staff-profiles/index">Staff Profile</a>
                           </li>
                           <li class="breadcrumb-item active">Add Staff Profile
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
            
          
			<div class="col s12 m12 ex-padd">  
            <div class="container view-Profile view-Profile-mobile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 bg-color-1 iq-card2 ">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Add Profile" classname="as" key="1">
						<div class="bb d-inline-block">
						 
						  
							<div class="col m2 s12 center children-add  h-167">
							
							{(() => {
								if (this.state.file_list == 0) {
									return (
										<>
											<label tabindex="0" class="pointer" role="button" for="image">
													<img src={person} className="pointer profile-img profile-img-mobile"/>
													 <img src={camera} class="profile-img-cam" />
													<input  onChange={this.handleFileSelect} class="file-upload__input file hide" type="file" name="files" id="image" accept="image/*" style={{display: 'none',opacity: '0'}}/> 
											</label>
											<input  onChange={this.handleFileSelectpdf} class="file-upload__input file hide" type="file" name="files" id="pdf" accept=".pdf" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
										</>
										)
								}else{
									return (
										<>
											{this.state.file_list.map((img) => (
												<>
												{(() => {
														return (
												
																		<div class="ant-upload-list ant-upload-list-picture-card">
																		<div class="ant-upload-list-item ant-upload-list-item-done">
																		   <div class="ant-upload-list-item-info">
																		  
																				
																				
																			<ModalImage  small={img.file_url} large={img.file_url} hideDownload="true" />
																			<button class="change-profile" id='remove' data-file={img.file_name} onClick={this.removeFile.bind(this,img.file_name)} type='button' title='Remove'><img src={camera} class="profile-img-cam-1"  />	</button>								
																			
																			
																			
																		</div>
																		</div>
																		</div>
														)						
																
												})()}
												</>
											))}
										</>
									)
								}
							})()}
						  

							
						  </div>
						  <div class="col m10 s12 no-padd">
								<div class="col m6 s12 mb-10">
									<label>First Name *</label>
									<input type="text" name="first_name"  onChange={this.handleSizeChange}   />
								</div>	
								<div class="col m6 s12 mb-10">
									<label>Last Name *</label>
									<input type="text" name="last_name"  onChange={this.handleSizeChange}   />
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Mobile No. *</label>
									<input type="text" name="mobile"  onChange={this.handleSizeChange}  />
									<span class="error" id="mob_error" ></span>
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Email *</label>
									<input type="text"  name="email"  onChange={this.handleSizeChange}  />
									<span class="error" id="email_error" ></span>
								</div>
								<div class="col m4 s12 mb-10">
									<label>Gender *</label>
									<Select  name="gender"  onChange={this.change_gender}>
										<Select.Option value="Male">Male</Select.Option>
										<Select.Option value="Female">Female</Select.Option>
										<Select.Option value="Other">Other</Select.Option>
									</Select>
								</div>	
						  </div>
						</div>  
						<div class="col m12 s12 mt-20 mb-10">
							<label>Residental Addresss *</label>
							<input type="text" name="address"  onChange={this.handleSizeChange} />
						</div>
						<div class="col m4 s12 mb-10">
									<label>Birthday *</label>
									<DatePicker onChange={this.onChangebirthday} />
								</div>	
								<div class="col m4 s12 mb-10">
									<label>Blood Group *</label>
									<Select name="blood_group"  onChange={this.change_blood_group}>
										<Select.Option value="A+">A+</Select.Option>
										<Select.Option value="A-">A-</Select.Option>
										<Select.Option value="B+">B+</Select.Option>
										<Select.Option value="B-">B-</Select.Option>
										<Select.Option value="AB+">AB+</Select.Option>
										<Select.Option value="AB-">AB-</Select.Option>
										<Select.Option value="O-">O-</Select.Option>
										<Select.Option value="O+">O+</Select.Option>
									</Select>
								</div>
								<div class="col m4 s12 mb-10">
									<label>Date of Joining *</label>
									<DatePicker onChange={this.onChangejoining} />
								</div>	
						</Panel>
					  </Collapse>
					</div> 
					
					<div class="children bg-blue communication mb-20 bg-color-6 iq-card2 staff-ch view">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Programs"  key="1">
						
						<Checkbox.Group  name="program"  onChange={this.onChangecheckedprog}>
							{this.state.program_list.map((list) => ( 
								<Checkbox value={list.id} id={`program_${list.id}`} ><label for={`program_${list.id}`} > {list.name} </label></Checkbox>
							))}
						 </Checkbox.Group>	
						</Panel>
					  </Collapse>
					</div>

					<div class="children bg-blue permision  bg-color-1 iq-card2 staff-ch view">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Permision"  key="1">
							<Checkbox.Group  name="permision"  onChange={this.onChangechecked}>
							  
							   <Checkbox value="Staff Permissions" id="Staff Permissions"><label for="Staff Permissions"> Staff Permissions </label></Checkbox>
								<Checkbox value="Enquiries Summary" id="Enquiries Summary"><label for="Enquiries Summary">Enquiries Summary </label></Checkbox>
							   <Checkbox value="Billing & Receipts" id="Billing & Receipts"><label for="Billing & Receipts">Billing & Receipts </label></Checkbox>
							   <Checkbox value="Child Daily Report" id="Child Daily Report"><label for="Child Daily Report">Child Daily Report </label></Checkbox>
							   <Checkbox value="Enquiries - New" id="Enquiries - New"><label for="Enquiries - New">Enquiries - New </label></Checkbox>
							   <Checkbox value="Children Profiles" id="Children Profiles"><label for="Children Profiles">Children Profiles </label></Checkbox>
							   <Checkbox value="Calendar" id="Calendar"><label for="Calendar">Calendar </label></Checkbox>
							   <Checkbox value="Call Parents" id="Call Parents"><label for="Call Parents">Call Parents </label></Checkbox>
							    <Checkbox value="Attendance" id="Attendance"><label for="Attendance">Attendance </label></Checkbox>
							   <Checkbox value="Kindergarden" id="Kindergarden"><label for="Kindergarden">Kindergarden </label></Checkbox>
							   
							   <Checkbox value="CCTV View" id="CCTV View"><label for="CCTV View">CCTV View </label></Checkbox>
								<Checkbox value="Delete a Post" id="Delete a Post"><label for="Delete a Post">Delete a Post </label></Checkbox>
								
								
								<Checkbox value="Diary" id="Diary"><label for="Diary">Diary </label></Checkbox>
								
								
								
							</Checkbox.Group>
							
							
						</Panel>
					  </Collapse>
					</div>					
					
					<div class="  bb pb-20 ">
					</div>
					
					<div class="col m12 s12 meal mt-20 mb-20 center">
						<Button className="cancel-btn large-btn"  onClick={this.goBack}>Back</Button>
						 <Button className="snd-btn large-btn" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
